import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { VALID_BE_ZIP_CODES } from "../constants/beZipCodesList";

export const zipCodeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const zipCode = control.value;

    if (!zipCode) { return null; }

    const isValid = VALID_BE_ZIP_CODES.includes(String(zipCode));
    return isValid ? null : { zipCodeInvalid: { value: zipCode } };
};

export function updateZipValidatorsByCountry(zipControl: AbstractControl | null, countryCode: string) {
    if (!zipControl) return;

    if (countryCode === "BE") {
        zipControl.setValidators([Validators.required, zipCodeValidator]);
    } else {
        zipControl.setValidators([Validators.required]);
    }
    
    zipControl.updateValueAndValidity({ emitEvent: false });
}